import { render, staticRenderFns } from "./ReplicaSet.vue?vue&type=template&id=cab908ba&"
import script from "./ReplicaSet.vue?vue&type=script&lang=js&"
export * from "./ReplicaSet.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports